export default __webpack_public_path__ + "static/media/CNo.49-1.b750dea5.jpg";